/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  ApplyDirectoryRoleSetupRole,
  ApplyDirectoryRoleSetupRole$Outbound,
  ApplyDirectoryRoleSetupRole$outboundSchema,
} from "./applydirectoryrolesetuprole.js";
import {
  RoleGrant,
  RoleGrant$Outbound,
  RoleGrant$outboundSchema,
} from "./rolegrant.js";

/**
 * approve, dismiss, or opt_out_key (new attribute values only).
 */
export const ResolveDirectoryReviewItemFormDecision = {
  Approve: "approve",
  Dismiss: "dismiss",
  OptOutKey: "opt_out_key",
} as const;
/**
 * approve, dismiss, or opt_out_key (new attribute values only).
 */
export type ResolveDirectoryReviewItemFormDecision = ClosedEnum<
  typeof ResolveDirectoryReviewItemFormDecision
>;

export type ResolveDirectoryReviewItemForm = {
  /**
   * approve, dismiss, or opt_out_key (new attribute values only).
   */
  decision: ResolveDirectoryReviewItemFormDecision;
  /**
   * Optional grants given to every role the approval creates. Existing roles are never changed.
   */
  grantSet?: Array<RoleGrant> | undefined;
  /**
   * The review item.
   */
  id: string;
  /**
   * The role set to map a new source to. Required and non-empty to approve a new source; must be empty or omitted otherwise.
   */
  roles?: Array<ApplyDirectoryRoleSetupRole> | undefined;
  /**
   * The item version from listDirectoryReviewItems. Required to approve.
   */
  version?: string | undefined;
};

/** @internal */
export const ResolveDirectoryReviewItemFormDecision$outboundSchema:
  z.ZodMiniEnum<typeof ResolveDirectoryReviewItemFormDecision> = z.enum(
    ResolveDirectoryReviewItemFormDecision,
  );

/** @internal */
export type ResolveDirectoryReviewItemForm$Outbound = {
  decision: string;
  grant_set?: Array<RoleGrant$Outbound> | undefined;
  id: string;
  roles?: Array<ApplyDirectoryRoleSetupRole$Outbound> | undefined;
  version?: string | undefined;
};

/** @internal */
export const ResolveDirectoryReviewItemForm$outboundSchema: z.ZodMiniType<
  ResolveDirectoryReviewItemForm$Outbound,
  ResolveDirectoryReviewItemForm
> = z.pipe(
  z.object({
    decision: ResolveDirectoryReviewItemFormDecision$outboundSchema,
    grantSet: z.optional(z.array(RoleGrant$outboundSchema)),
    id: z.string(),
    roles: z.optional(z.array(ApplyDirectoryRoleSetupRole$outboundSchema)),
    version: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      grantSet: "grant_set",
    });
  }),
);

export function resolveDirectoryReviewItemFormToJSON(
  resolveDirectoryReviewItemForm: ResolveDirectoryReviewItemForm,
): string {
  return JSON.stringify(
    ResolveDirectoryReviewItemForm$outboundSchema.parse(
      resolveDirectoryReviewItemForm,
    ),
  );
}
